import {Icon, IconName} from '@components/@icons';
import {IconLogoTitle} from '@components/@icons/@custom';
import {MeinText} from '@components/@typography/MeinText';
import {MeinButton} from '@components/@ui';
import {sendSnackbarMessage} from '@utils/sendSnackbarMessage';
import {useTranslations} from 'next-intl';
import {FC} from 'react';
import styles from './ErrorPage.module.css';

export interface INextErrorPageProps {
    error: Error & {digest: number};
    reset: () => void;
}

interface IProps {
    body: string;
    buttonLabel: string;
    buttonIcon: IconName;
    title: string;
    onClick: () => void;
    error?: Error;
}

const ErrorPage: FC<IProps> = ({
    body,
    buttonIcon,
    title,
    buttonLabel,
    onClick,
    error,
}) => {
    const t = useTranslations('error500');

    const copyError = () => {
        const message = error?.message;
        const stack = error?.stack;
        const name = error?.name;
        const errorDetails = `
        ${name}
        ${message}
        **** STACKTRACE START ****
        ${stack}
        **** STACKTRACE END ****
        `;

        navigator.clipboard.writeText(errorDetails);
        sendSnackbarMessage({
            message: t('copied'),
        });
    };

    return (
        <main className={styles.page}>
            <div className={styles.content}>
                <IconLogoTitle
                    className={styles.logo}
                    width={170}
                    height={48}
                />
                <MeinText
                    type="headline"
                    tag="h1"
                    size="l"
                    className={styles.body}
                >
                    {body}
                </MeinText>
                <div className={styles.bodyAndLog}>
                    <MeinText type="headline" tag="h2" size="m">
                        {title}
                    </MeinText>
                    {!!error && (
                        <MeinButton
                            onClick={copyError}
                            variant="text"
                            className={styles.logButton}
                        >
                            <Icon name="copy" className={styles.iconCopy} />
                        </MeinButton>
                    )}
                </div>
                <MeinButton
                    onClick={onClick}
                    variant="outlined"
                    className={styles.button}
                >
                    <Icon name={buttonIcon} className={styles.icon} />
                    {buttonLabel}
                </MeinButton>
            </div>
        </main>
    );
};

export default ErrorPage;
